import React from 'react';
import { navigate } from 'gatsby';
import Article from '../templates/insights';
import Page from '../templates/page';
import ProjectCategory from '../templates/projectCategory';
import Project from '../templates/projects';
import ServiceCategory from '../templates/serviceCategory';
import Service from '../templates/services';

export const UnpublishedPage = props => {
  const IS_BROWSER = typeof window !== 'undefined';
  if (!IS_BROWSER) return null;
  const data = window.__PRISMIC_PREVIEW_DATA__;
  if (!data) {
    navigate('/404');
    return null;
  }
  const { prismicArticle, prismicProjectCategory, prismicProject, prismicServiceCategory, prismicService } = data;

  // => Perform any logic from previewData to determine the correct page or template component to use.
  if (prismicArticle) {
    return <Article {...props} data={data} />;
  }
  if (prismicProjectCategory) {
    return <ProjectCategory {...props} data={data} />;
  }
  if (prismicProject) {
    return <Project {...props} data={data} />;
  }
  if (prismicServiceCategory) {
    return <ServiceCategory {...props} data={data} />;
  }
  if (prismicService) {
    return <Service {...props} data={data} />;
  }
  return <Page {...props} data={data} />;
};

export default UnpublishedPage;
